import { render } from "./LoadingProductCardComponent.vue?vue&type=template&id=4a5ae8a0&scoped=true"
const script = {}

import "./LoadingProductCardComponent.vue?vue&type=style&index=0&id=4a5ae8a0&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5ae8a0"]])

export default __exports__